import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { SharedService, Status, RowsPerOptions } from '../../shared/shared.service';
import { PagerList, GlobalInfo, FPMessage, Severities, FPResponse } from '../../shared/shared.model';
import { BaseComponent } from '../../shared/base.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Message, ConfirmationService, SelectItem } from 'primeng/primeng';
import { DatePipe } from '@angular/common';
import { CapitalizeFirstPipe } from '../../shared/pipes/custom-pipes.pipe';
import { EquipmentEntity, EquipmentEntitys, WoEquipmentEntity, RemovedEquipments, KeyValue, WoEquipmentCFModel } from '../../technician/technician-jobs/technician-jobs.models';
import { CustomFieldsUpdater, CustomFieldUpdaterService } from '../../shared/custom-fields/custom-fields-updater.service';
import { CustomFieldsConfiguration } from '../../shared/custom-fields/custom-fields-models';

import { Job, PartWareHouse, SerialNumber, AllocatePart, SpErrors, PartPricing, Logo, PartRequest, PartReqStatus, JobPricing, CoreReturnStatus, RefOEMPartReqType } from '../../work-order/work-order-models';
import { WoService } from '../../work-order/work-order.service';
import { compareValidator } from '../../shared/custom-validators/custom-validator.directive';
import { Type, Operator } from '../../shared/custom-validators/custom-validator.model';
import { DISABLED } from '@angular/forms/src/model';
import { LoaderService } from '../../shared/loader.service';
import { AuthService } from '../../../authentication/auth.service';
import { API } from '../.././core/app-config';

@Component({
    selector: 'add-edit-part-request-popup',
    templateUrl: 'add-edit-part-request.html'
})

export class PartRequestAddEditComponent extends BaseComponent implements OnInit {


    @Input() woWorkOrderId: number;
    @Input() HeaderName: string;
    @Input() eventName: string;

    @Output() done = new EventEmitter();
    //@Input() woCustomerId: number;
    @Input() wojobId: number;
    @Input() rights: any;

    @Input() partId: number;
    @Input() partReqStatusId: number;
    @Input() partRequestId: number;

    @Input() OEM: boolean;
    @Input() isOther: boolean;
    @Input() isOemPartsQueue: boolean = false;
    @Input() isPartRequestApprovalQueue: boolean = false;
    @Input() filterJobNumber: number[];
    @Input() BOQ: boolean = false;
    @Input() VendorApprovalstatus?: number;
    @Input() SubmitButton?: boolean;
    isExistEqipmentPopup: boolean = false;
    message: FPMessage;
    loader: boolean = false;
    frmAddNewPart: FormGroup;

    public rowsperOptions: any;
    public getRows: number;
    public partWareHouse: PartWareHouse[] = [];

    public serialNumber: SerialNumber[] = [];
    public tempserialNumber: SerialNumber[] = [];

    public partRequest: PartRequest;

    public allocatePart: AllocatePart;
    public spErrors: SpErrors;

    job: Job[] = [];

    submitted: boolean = false;
    editPart: PartRequest = new PartRequest();
    islookup: boolean = false;
    isseriallookup: boolean = false;
    jobstatus: boolean = false;
    jobCompletedStatus: boolean = false;
    jobStatusId: number;
    jobId: number;
    serialized: boolean = false;
    IsSerialized: number;
    PartId: number;
    WhId: number;
    SerialNo: string;
    jobstatuswarehouse: boolean = false;
    TaxIdGroupId: number;
    TaxTypeId: number;
    partDescription: string;
    partrequeststatus: boolean = false;
    OemFlag: boolean = true;
    coreReturnFlag: boolean = true;
    isCorereturnMand: boolean = false;

    //THIS FLAG ONLY OEM AND CORE RETURN FLAG TRUE ENABLE STATUS INSTALLED
    insOemFlag: number = 0;
    inscoreReturnFlag: number = 0;

    //THIS FLAG ONLY OEM AND CORE RETURN FLAG TRUE ENABLE STATUS INSTALLED
    isEdit: boolean = false;
    oemandallocated: boolean = false;
    fromtechnician: boolean = false;

    public partReqStatus: PartReqStatus[] = [];
    oempartStatus: boolean = false;
    yearRange: string;
    showLookup: boolean = true;
    public WoPartPriceId: number;
    partPricing: PartPricing = new PartPricing;
    public coreReturnStatus: CoreReturnStatus[] = [];
    isOEMInventory: boolean = false;
    disableOEM: string;
    refOEMPartReqTypeList: RefOEMPartReqType[] = [];
    url: string;
    imageAcceptTypes: string = 'image/*';//'.jpg,.jpeg,.gif';
    docAcceptTypes = "audio/*,.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf";
    path: string = '';

    DropPointtext: string = '';
    logo: Logo = new Logo();
    @ViewChild("fileInput") fileInput;
    dateTimeNow: string;
    oemedit: boolean = false;
    dWarehouse: string = '';

    constructor(protected sharedService: SharedService, protected translate: TranslateService, protected _woService: WoService,
        private confirmationService: ConfirmationService, private updater: CustomFieldUpdaterService, private loaderservice: LoaderService,
        private datePipe: DatePipe, private _fb: FormBuilder, private authService: AuthService) {
        super(sharedService, translate);
        this.yearRange = sharedService.yearRange;

        //Table paginations
        this.rowsperOptions = this.sharedService.getRowsPerOptions();
        this.getRows = this.sharedService.getRows();
    }

    ngOnInit() {
        debugger;

        this.frmAddNewPart = this._fb.group({
            JobId: ['', Validators.required],
            PartNo: ['', Validators.required],
            Description: ['', Validators.maxLength(1000)],
            Price: ['', Validators.maxLength(1000)],
            Uom: ['', Validators.maxLength(1000)],
            Notes: ['', Validators.maxLength(1000)],
            WarehouseId: [''],
            AvailableQuantity: [''],
            RequestedQuantity: ['', Validators.compose([Validators.required, compareValidator(null, Type.number, Operator.DataTypeCheck)])],
            Serialize: [0],
            IsOEM: [0],
            IsCoreReturn: [0],
            SerialNo: [''],
            PartNotes: ['', Validators.maxLength(1000)],
            OEMName: ['', Validators.maxLength(1000)],
            OrderNo: ['', Validators.maxLength(1000)],
            ShipVia: ['', Validators.maxLength(1000)],
            ShippingDate: [''],
            TrackingNo: ['', Validators.maxLength(1000)],
            ETADate: [''],
            ETATime: ['', Validators.maxLength(1000)],
            RMANo: ['', Validators.maxLength(1000)],
            RMATrackingNo: ['', Validators.maxLength(1000)],
            RMAShippingDate: [''],
            RMANotes: ['', Validators.maxLength(1000)],
            PartStatusId: [''],
            PartRequestNo: [''],
            CoreReturnStatusID: [''],
            ReturnNotes: [''],
            DropPoint: [''],
            RequestType: [1],
            ReceivedOn: ['']
        });

        this._woService.getCustomerTime(super.globalInfo().TimeZoneId).subscribe(s => {
            this.dateTimeNow = s.CustomerDateTime;
            this.frmAddNewPart.controls['ReceivedOn'].setValue(this.dateTimeNow);
        });
        this._woService.getCoreReturnStatus(super.globalInfo().CompanyId).subscribe(s => {
            this.coreReturnStatus = s;
        });
        this._woService.getAllRefOEMPartReqType(super.globalInfo().CompanyId).subscribe(s => {
            this.refOEMPartReqTypeList = s;
        });

        if (this.OEM) {
            this._woService.getPartReqStatus(super.globalInfo().CompanyId).subscribe(s => {
                this.partReqStatus = s;
            });
        }

        if (this.wojobId != null)
            this.fromtechnician = true;

        if (this.partRequestId != 0) {
            this.isEdit = true;
            if (this.isOemPartsQueue)
                this.frmAddNewPart.controls["RequestType"].disable();
            if (this.partReqStatusId == 4 || this.partReqStatusId == 5) {
                this.partrequeststatus = false;
                this.oemandallocated = true;
            }
            else if (this.partReqStatusId == 3) {
                this.partrequeststatus = false;
                this.oemandallocated = true;
                // JIRA PROD-91
                this.frmAddNewPart.controls["PartStatusId"].disable();



            }
            else {
                this.partrequeststatus = true;
                if (!this.isOemPartsQueue)
                    this.frmAddNewPart.controls["PartStatusId"].enable(); // JIRA PROD-91

            }
        }
        else {
            this.isEdit = false;
            this.frmAddNewPart.controls["RequestType"].enable();
        }


        if (this.allocatePart == null) {
            this.allocatePart = new AllocatePart;
        }

        if (this.spErrors == null) {
            this.spErrors = new SpErrors;
        }

        if (this.message == null) {
            this.message = new FPMessage;
        }

        if (this.partRequest == null) {
            this.partRequest = new PartRequest;
        }

        this.partWareHouse = [];


        this._woService.getJobId(super.globalInfo().CompanyId, this.woWorkOrderId)
            .subscribe(s => {
                // if (this.filterJobNumber)
                //     this.job = s.filter(m => this.filterJobNumber.indexOf(m.WoJobId) != -1);
                // else
                debugger;
                this.job = s;
                if (this.partId != 0) {
                    this._woService.getByPartRequest(super.globalInfo().CompanyId, this.partRequestId)
                        .subscribe(s => {

                            this.editPart = s;
                            this.WoPartPriceId = s.WoPartPriceId;
                            this.TaxTypeId = s.TaxTypeId;
                            this.TaxIdGroupId = s.TaxIdGroupId;
                            this.PartId = s.PartId;
                            this.IsSerialized = s.IsSerialized;
                            this.serialNumber = s.SerialNo;
                            this.wojobId = s.WoJobId;
                            this.insOemFlag = s.IsOEM
                            this.inscoreReturnFlag = s.IsCoreReturn
                            this.frmAddNewPart.patchValue({

                                JobId: s.WoJobId,
                                PartNo: s.PartNo,
                                PartRequestNo: s.PartRequestNo,
                                Description: s.Description,
                                WarehouseId: s.WarehouseId == null ? '' : s.WarehouseId,
                                RequestedQuantity: s.RequestedQty,
                                Serialize: s.IsSerialized,
                                SerialNo: [],
                                Uom: s.Uom,
                                MovingCost: s.MovingCost,
                                Price: s.UnitPrice,
                                PartNotes: s.PartNotes,
                                IsOEM: s.IsOEM,
                                IsCoreReturn: s.IsCoreReturn,
                                OEMName: s.OEMName,
                                OrderNo: s.OrderNo,
                                ShipVia: s.ShipVia,
                                ShippingDate: s.ShippingDate == null ? null : new Date(s.ShippingDate),
                                TrackingNo: s.TrackingNo,
                                ETADate: s.ETADate == null ? null : new Date(s.ETADate),
                                ETATime: s.ETATime == null ? null : new Date(s.ETATime),
                                RMANo: s.RMANo,
                                RMATrackingNo: s.RMATrackingNo,
                                RMAShippingDate: s.RMAShippingDate == null ? null : new Date(s.RMAShippingDate),
                                RMANotes: s.RMANotes,
                                PartStatusId: s.RequestStatusId == null ? '' : s.RequestStatusId,
                                CoreReturnStatusID: s.CoreReturnStatusID == null ? '' : s.CoreReturnStatusID,
                                ReturnNotes: s.CoreReturnNotes == null ? '' : s.CoreReturnNotes,
                                DropPoint: s.DropPoint ? s.DropPoint : '',
                                RequestType: s.OEMPartReqTypeId > 0 ? s.OEMPartReqTypeId : 1,
                                ReceivedOn: s.ReceivedOn ? s.ReceivedOn : this.dateTimeNow
                            });

                            this.DropPointtext = s.DropPoint ? s.DropPoint : '',
                                this.OEM = s.IsOEM == 1;
                            if (this.OEM) {
                                this.oemedit = true;
                                this._woService.getPartReqStatus(super.globalInfo().CompanyId).subscribe(s => {
                                    this.partReqStatus = s;
                                });
                                if (s.Attachement) {
                                    this._woService.GetOemPartReqAttachement(this.globalInfo().CompanyId, this.partRequestId, s.Attachement).subscribe(lo => {
                                        this.logo = lo;
                                    });
                                }
                            }
                        });


                }
                else {

                    if (this.wojobId != null) {

                        this.frmAddNewPart.controls['JobId'].setValue(this.wojobId);
                    }
                    else if (this.job.length == 1)
                        this.frmAddNewPart.controls['JobId'].setValue(this.job[0].WoJobId);
                }
            });

        //OEM inventory only logic added based on company settings
        this.sharedService.getSystemSettingByIds(this.globalInfo().CompanyId, 123).subscribe(value => {
            this.isOEMInventory = (value[0].SettingValue == "1") ? true : false;
            if (this.isOEMInventory) {
                this.OemFlag = false;
                this.frmAddNewPart.controls['IsOEM'].setValue(1);
                this.disableOEM = 'none';
                if (this.partReqStatusId == 3) {
                    this.partrequeststatus = true;
                    this.oemandallocated = true;
                }
            }
            else {
                this.OemFlag = true;
                this.disableOEM = '';
                if (this.partRequestId == 0) {
                    this.frmAddNewPart.controls['IsCoreReturn'].setValue(0);
                }
            }
        });


        this.frmAddNewPart.controls['JobId'].valueChanges.subscribe(value => {

            // Awaiting Schedule, Tentative, Unresolved   --- > warehouse and available qty not visible (Add button will visible)
            // Completed, Cancelled -- not allow to add part request (Add button will not visible)
            // Scheduled, En Route, On Site   --- > warehouse and available qty visible (Add button will visible)
            if (value != 0) {
                this.jobId = value;
                this.jobStatusId = this.job.find(w => w.WoJobId == value).JobStatusId;
                console.log("job status Id -------> " + this.jobStatusId);
                if (this.jobStatusId == 1 || this.jobStatusId == 6 || this.jobStatusId == 8) {
                    this.jobstatus = false;
                    this.jobCompletedStatus = true;
                    this.partWareHouse = [];
                }
                else if ((!this.isOther && this.jobStatusId == 5) || this.jobStatusId == 7) {
                    this.jobstatus = false;

                    if (this.VendorApprovalstatus == 1 || this.SubmitButton)//vendor approvall part request,before submit
                    {
                        this.jobstatus = true;
                        this.jobCompletedStatus = true;
                        this._woService.getPartWareHouse(super.globalInfo().CompanyId, this.jobId)
                            .subscribe(s => {
                                this.partWareHouse = s;
                                let findWarehouse = s.find(f => f.WarehouseId == this.frmAddNewPart.value.WarehouseId);
                                this.dWarehouse = (findWarehouse ? findWarehouse.Warehouse : '');
                            });
                    }
                    else {
                        this.jobCompletedStatus = false;
                    }

                    this.partWareHouse = [];

                }
                else if (this.isOther && this.partReqStatusId == 4 && this.insOemFlag == 1) {
                    this.jobstatus = false;
                    this.jobCompletedStatus = true;
                    this.partrequeststatus = true;
                    this.partWareHouse = [];
                }
                else {
                    this.jobstatus = true;
                    this.jobCompletedStatus = true;
                    this._woService.getPartWareHouse(super.globalInfo().CompanyId, this.jobId)
                        .subscribe(s => {
                            this.partWareHouse = s;
                            let findWarehouse = s.find(f => f.WarehouseId == this.frmAddNewPart.value.WarehouseId);
                            this.dWarehouse = (findWarehouse ? findWarehouse.Warehouse : '');
                        });
                }
            }
            else {
                this.jobstatus = true;
                this.jobCompletedStatus = true;
                this.partWareHouse = [];
            }

            this.frmAddNewPart.controls['WarehouseId'].setValue('');
        });

        this.frmAddNewPart.controls['WarehouseId'].valueChanges.subscribe(value => {
            if (value != 0) {
                //Add Serial number block condition
                if (this.IsSerialized == 1) {
                    this.serialized = true;
                }
                else {
                    this.serialized = false;
                }

                if (this.PartId != 0 && this.PartId != undefined) {
                    this._woService.getPartWareHouseQuantity(super.globalInfo().CompanyId, this.PartId, value)
                        .subscribe(s => {
                            this.frmAddNewPart.controls['AvailableQuantity'].setValue(s.count);
                        });
                }
                else {
                    this.frmAddNewPart.controls['AvailableQuantity'].setValue('');
                }
                this.jobstatuswarehouse = false;
            }
            else {
                this.serialized = false;
                this.frmAddNewPart.controls['AvailableQuantity'].setValue('');

                if (this.submitted == true)
                    this.jobstatuswarehouse = true;
                else
                    this.jobstatuswarehouse = false;
            }

        });

        this.frmAddNewPart.controls['IsOEM'].valueChanges.subscribe(value => {

            if (value == false || value == 0) {
                this.OemFlag = true;

                if (this.partRequestId == 0) {
                    this.frmAddNewPart.controls['IsCoreReturn'].setValue(false);
                }
            }
            else {
                this.OemFlag = false;

                if (this.partReqStatusId == 3) {
                    this.partrequeststatus = true;
                    this.oemandallocated = true;
                }
            }
        });

        this.frmAddNewPart.controls['IsCoreReturn'].valueChanges.subscribe(value => {

            if (value == false || value == 0) {
                this.coreReturnFlag = true;
                this.inscoreReturnFlag = 0;

            }
            else {
                this.coreReturnFlag = false;
                this.inscoreReturnFlag = 1;
            }
        });
        if (this.isOther && this.isEdit) {
            this.showLookup = false;
        }
        if (this.partReqStatusId == 2)
            this.showLookup = false;

        this.frmAddNewPart.controls['RequestedQuantity'].valueChanges.subscribe(x => {

            var str: string = x;
            if (str && str.toString().includes('.')) {
                this.decimalPoint = true;
            }
            else
                this.decimalPoint = false;
        });
    }
    decimalPoint: boolean = false;
    addOrEditPart(frmAddNewPart, isValidForm: boolean) {
        debugger;

        this.submitted = true;
        if (isValidForm && !this.decimalPoint) {
            let file: File = this.fileInput.files[0];

            if (file != null) {
                if (file.size == 0) {
                    // alert("File size is 0 bytes");
                    this.sharedService.notification.emit({
                        severity: Severities[2],
                        summary: CapitalizeFirstPipe.prototype.transform(Severities[2]),
                        detail: this.translate.instant("File size is 0 bytes")
                    });
                    return;
                }
                if (file.size > 4000000) {
                    this.sharedService.notification.emit({
                        severity: Severities[2],
                        summary: CapitalizeFirstPipe.prototype.transform(Severities[2]),
                        detail: this.translate.instant("UPLOADLIMIT4MB")
                    });
                    return;
                }

                if (!this.sharedService.isFileTypeValid(file, this.imageAcceptTypes) && !this.sharedService.isFileTypeValid(file, this.docAcceptTypes)) {
                    this.sharedService.notification.emit({
                        severity: Severities[2],
                        summary: CapitalizeFirstPipe.prototype.transform(Severities[2]),
                        detail: this.translate.instant("INVALIDFILETYPE")
                    });
                    return;
                }
                // var filesplit = file.name.split('.');
                this.path = file.name;//insCustomerType.CustomerType + '.' + filesplit[1];
                this.url = API.COMPANY + '/UploadFile?CompanyId=' + this.globalInfo().CompanyId + '&Id=' + this.partRequestId + '&ModuleName=OemPartRequest&FileName=' + this.path;

                //this.path = file.name //Profile Photo;
            }
            var shipdate = this.frmAddNewPart.controls['ShippingDate'].value;
            var etadate = this.frmAddNewPart.controls['ETADate'].value;
            var etatime = this.frmAddNewPart.controls['ETATime'].value;

            if ((shipdate != null && etadate != null) && etadate < shipdate) {
                this.sharedService.notification.emit({ severity: Severities[Severities.error], summary: CapitalizeFirstPipe.prototype.transform(Severities[Severities.error]), detail: this.translate.instant('ETADATECHECK') });
                return;
            }
            if (this.frmAddNewPart.controls['RequestedQuantity'].value <= 0) {
                this.sharedService.notification.emit({ severity: Severities[Severities.error], summary: CapitalizeFirstPipe.prototype.transform(Severities[Severities.error]), detail: this.translate.instant('REQUESTEDQUANTITYGREATER') });
                return;
            }
            if (etadate == null && etatime != null) {
                this.sharedService.notification.emit({ severity: Severities[Severities.error], summary: CapitalizeFirstPipe.prototype.transform(Severities[Severities.error]), detail: this.translate.instant('ETADATETIMECHECK') });
                return;
            }
            if (this.isOther == true && this.isEdit) {

                if (!this.OemFlag && !this.coreReturnFlag && this.frmAddNewPart.controls['CoreReturnStatusID'].value == '') {
                    this.sharedService.notification.emit({ severity: 'error', summary: this.translate.instant('2079') });
                    return;
                }


            }

            if (this.OEM == false) {

                this.allocatePart.ReqQty = this.frmAddNewPart.controls['RequestedQuantity'].value;
                var availableqty = this.frmAddNewPart.controls['AvailableQuantity'].value;

                if (this.OemFlag && this.coreReturnFlag && (this.jobStatusId == 2 || this.jobStatusId == 3 || this.jobStatusId == 4) && this.frmAddNewPart.controls['WarehouseId'].value == '') {
                    this.jobstatuswarehouse = true;
                    return;
                }
                if (this.OemFlag && this.coreReturnFlag && (this.jobStatusId == 5) && this.frmAddNewPart.controls['WarehouseId'].value == '') {
                    if (this.VendorApprovalstatus == 1) {

                    }
                    else {
                        this.jobstatuswarehouse = true;
                        return;
                    }


                }
                // if (this.frmAddNewPart.controls['WarehouseId'].value != '' && availableqty < this.allocatePart.ReqQty) {
                //     this.sharedService.notification.emit({ severity: 'error', summary: this.translate.instant('2053') });
                // }
                if (this.IsSerialized == 1 && this.OemFlag && this.coreReturnFlag && availableqty < this.allocatePart.ReqQty && this.serialNumber.length > 0) {
                    // this.sharedService.notification.emit({ severity: 'error', summary: this.translate.instant('2066') });
                    this.sharedService.notification.emit({ severity: Severities[Severities.error], summary: CapitalizeFirstPipe.prototype.transform(Severities[Severities.error]), detail: this.translate.instant('2066') });
                }
                else if (this.IsSerialized == 1 && this.OemFlag && this.coreReturnFlag && availableqty >= this.allocatePart.ReqQty && this.serialNumber.length == 0)
                    // this.sharedService.notification.emit({ severity: 'error', summary: this.translate.instant('2081') });
                    this.sharedService.notification.emit({ severity: Severities[Severities.error], summary: CapitalizeFirstPipe.prototype.transform(Severities[Severities.error]), detail: this.translate.instant('2081') });
                else if (this.IsSerialized == 1 && this.OemFlag && this.coreReturnFlag && availableqty >= this.allocatePart.ReqQty && this.serialNumber.length != this.allocatePart.ReqQty) {
                    // this.sharedService.notification.emit({ severity: 'error', summary: this.translate.instant('2067') });
                    this.sharedService.notification.emit({ severity: Severities[Severities.error], summary: CapitalizeFirstPipe.prototype.transform(Severities[Severities.error]), detail: this.translate.instant('2067') });
                }
                // else if ((this.jobStatusId == 2 || this.jobStatusId == 3 || this.jobStatusId == 4) && this.IsSerialized == 1 && this.allocatePart.ReqQty <= this.serialNumber.length) {
                //     this.sharedService.notification.emit({ severity: 'error', summary: this.translate.instant('2049') });
                // }
                else {
                    if ((this.jobStatusId == 2 || this.jobStatusId == 3 || this.jobStatusId == 4) && this.OemFlag && this.coreReturnFlag && availableqty < this.allocatePart.ReqQty) {
                        this.confirmationService.confirm({
                            message: this.translate.instant('5060'),
                            header: this.translate.instant('CONFIRMATION'),
                            icon: 'fa fa-warning',
                            accept: () => {
                                this.save();
                                let pdialog = document.querySelector("p-confirmdialog div");
                                if (pdialog) pdialog.remove();

                            },
                            reject: () => {
                                let pdialog = document.querySelector("p-confirmdialog div");
                                if (pdialog) pdialog.remove();
                            }
                        });
                    }
                    else {
                        this.save();
                    }
                }

            }
            else {
                this.allocatePart.PartOEM = 1;
                if (this.OEM && this.frmAddNewPart.controls['PartStatusId'].value == '') {
                    this.sharedService.notification.emit({ severity: 'error', summary: this.translate.instant('2078') });
                    return;
                }
                else {
                    this.oempartStatus = false;
                    this.allocatePart.RequestStatusId = this.frmAddNewPart.controls['PartStatusId'].value;
                    this.save();
                }
            }
        }
    }

    save() {

        this.loaderservice.show();
        this.allocatePart.CompanyId = this.globalInfo().CompanyId;
        this.allocatePart.loginid = this.globalInfo().LoginId;
        this.allocatePart.WorkOrderId = this.woWorkOrderId;
        this.allocatePart.JobId = this.jobId;
        this.allocatePart.PartId = this.PartId;
        this.allocatePart.IsSerialized = this.IsSerialized;

        this.allocatePart.WhId = (!this.OemFlag || !this.coreReturnFlag) ? null : this.frmAddNewPart.controls['WarehouseId'].value;
        this.allocatePart.SerialNo = this.serialNumber;

        this.allocatePart.PartNotes = this.frmAddNewPart.controls['PartNotes'].value;
        this.allocatePart.IsOEM = this.frmAddNewPart.controls['IsOEM'].value;
        this.allocatePart.IsCoreReturn = this.frmAddNewPart.controls['IsCoreReturn'].value;
        this.allocatePart.OEMName = this.frmAddNewPart.controls['OEMName'].value;
        this.allocatePart.OrderNo = this.frmAddNewPart.controls['OrderNo'].value;
        this.allocatePart.ShipVia = this.frmAddNewPart.controls['ShipVia'].value;
        this.allocatePart.ShippingDate = this.frmAddNewPart.controls['ShippingDate'].value ? new Date(this.frmAddNewPart.controls['ShippingDate'].value).toDateString() : null;
        this.allocatePart.TrackingNo = this.frmAddNewPart.controls['TrackingNo'].value;
        this.allocatePart.ETADate = this.frmAddNewPart.controls['ETADate'].value ? new Date(this.frmAddNewPart.controls['ETADate'].value).toDateString() : null;
        this.allocatePart.ETATime = this.frmAddNewPart.controls['ETATime'].value //; ? new Date(this.frmAddNewPart.controls['ETATime'].value).toDateString() : null;
        this.allocatePart.RMANo = this.frmAddNewPart.controls['RMANo'].value;
        this.allocatePart.RMATrackingNo = this.frmAddNewPart.controls['RMATrackingNo'].value;
        this.allocatePart.RMAShippingDate = this.frmAddNewPart.controls['RMAShippingDate'].value ? new Date(this.frmAddNewPart.controls['RMAShippingDate'].value).toDateString() : null;
        this.allocatePart.RMANotes = this.frmAddNewPart.controls['RMANotes'].value;
        this.allocatePart.SourceID = 1; //From web always 1 - added by Anvardeen Batcha 
        this.allocatePart.CoreReturnStatusID = this.frmAddNewPart.controls['CoreReturnStatusID'].value;
        this.allocatePart.CoreReturnNotes = this.frmAddNewPart.controls['ReturnNotes'].value;
        this.allocatePart.OEMPartReqTypeId = this.frmAddNewPart.controls['RequestType'].value;
        if (this.allocatePart.IsOEM == 1) {
            this.allocatePart.DropPoint = this.frmAddNewPart.controls['DropPoint'].value;
            if (!this.oemandallocated && this.isEdit && this.frmAddNewPart.controls['PartStatusId'].value == 3) {
                this.allocatePart.Attachement = this.path;
                this.allocatePart.ReceivedOn = this.dateTimeNow;
            }
            if (this.oemandallocated) {
                this.allocatePart.Attachement = this.editPart.Attachement;
                this.allocatePart.ReceivedOn = this.editPart.ReceivedOn;
            }
        }

        this.allocatePart.CreatedBy = this.globalInfo().LoginId;
        if (this.isOther && this.partReqStatusId == 4 && this.insOemFlag == 1 && this.inscoreReturnFlag == 1) {
            this.allocatePart.PartOEM = 1;
        }

        this.allocatePart.RequestStatusId = this.frmAddNewPart.controls['PartStatusId'].value;


        if (this.partRequestId != 0)
            this.allocatePart.PartRequestId = this.partRequestId;
        else
            this.allocatePart.PartRequestId = null;



        var jobpartPricing = new PartPricing;

        jobpartPricing.priceIndx = 0;
        jobpartPricing.TaxTypeId = this.TaxTypeId;
        jobpartPricing.TaxIdGroupId = this.TaxIdGroupId;
        jobpartPricing.description = this.frmAddNewPart.controls['Description'].value;
        jobpartPricing.PartRequestId = this.allocatePart.PartRequestId;
        jobpartPricing.unitPrice = this.frmAddNewPart.controls['Price'].value;
        jobpartPricing.TaskNo = 0;
        jobpartPricing.wopartpriceid = this.WoPartPriceId;

        if (this.partRequestId != 0)
            jobpartPricing.qty = this.allocatePart.ReqQty;
        else
            jobpartPricing.qty = 1;
        jobpartPricing.total = 0;
        jobpartPricing.discount = 0;
        jobpartPricing.DiscountTypeId = 80;
        jobpartPricing.NetTotal = 0;
        jobpartPricing.JobTotal = 0;
        jobpartPricing.priceTypeId = 270;
        jobpartPricing.CreatedBy = this.globalInfo().LoginId;
        jobpartPricing.LastChangedBy = this.globalInfo().LoginId;
        this.allocatePart.partPricing = jobpartPricing;
        if (!this.frmAddNewPart.controls['RequestedQuantity'].disabled)
            this.allocatePart.ReqQty = this.frmAddNewPart.controls['RequestedQuantity'].value;
        this._woService.insertAllocatePartRequest(this.allocatePart)
            .subscribe(s => {
                this.sharedService.emitAuditlog.emit({ auditMessage: "PartRequest" });
                this.spErrors = s;
                this.spErrors.PoErrorCode = s.PoErrorCode;
                //this.sharedService.emitAuditlog.emit({auditMessage:"partRequest"});

                if (s.PoErrorCode == '9000' || s.PoErrorCode == '1001') {
                    let file: File = this.fileInput.files[0];
                    if (file != null) {
                        this.fileInput.upload();
                    }
                    this.closePopup(true);
                    this.loaderservice.hide();
                }
                else {
                    this.closePopup(false);
                    this.loaderservice.hide();
                }
            }, e => {
                this.loaderservice.hide();
            });
    }

    closePopup(success?: boolean) {
        if (success === true || success === false) {
            if (this.spErrors.PoErrorCode == "1001") {
                this.message.Severity = 0;
                this.sharedService.notification.emit({
                    severity: Severities[this.message.Severity],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                    detail: this.translate.instant('PARTREQUESTUPDATEDSUCCESSFULLY')
                });
            }
            else {
                if (this.spErrors.PoErrorCode == "9000") {
                    if (this.partRequestId != 0)
                        this.message.MessageCode = "1024";
                    else
                        // this.message.MessageCode = this.translate.instant('1023') + " " + this.frmAddNewPart.controls['PartNo'].value + " " + this.translate.instant('1029');
                        this.message.MessageCode = this.translate.instant('1023') + " " + this.translate.instant('1029');
                    this.message.Severity = 0;
                }
                if (this.spErrors.PoErrorCode == "7098") {
                    this.message.MessageCode = "2052";
                    this.message.Severity = 3;
                }

                if (this.spErrors.PoErrorCode == "7401") {
                    this.message.MessageCode = "7401";
                    this.message.Severity = 3;
                }
                if (this.spErrors.PoErrorCode == "7402") {
                    this.message.MessageCode = "7402";
                    this.message.Severity = 3;
                }
                if (this.spErrors.PoErrorCode == "7403") {
                    this.message.MessageCode = "7403";
                    this.message.Severity = 3;
                }
                if (this.spErrors.PoErrorCode == "7404") {
                    this.message.MessageCode = "7404";
                    this.message.Severity = 3;
                }
                this.sharedService.notification.emit({
                    severity: Severities[this.message.Severity],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                    detail: this.translate.instant(this.message.MessageCode)
                });
            }
            this.done.emit(success);

        } else {
            this.done.emit(true);
        }
    }

    responceMessage(res: any) {

        this.loader = false;
        this.message = res.Message;
        if (res.Message.Severity == Severities.success) this.closePopup(true); else this.closePopup(false);
    }

    openPartLookup() {

        this.islookup = true;
    }

    closesearch(responsedata: any) {

        if (responsedata != null && responsedata != 0) {
            var res = responsedata.data;
            this.frmAddNewPart.patchValue({
                PartNo: res.PartNo,
                Description: res.Description,
                Serialize: res.IsSerialized == 1 ? true : false,
                Uom: res.Uom,
                Price: res.UnitPrice
            })
            this.IsSerialized = res.IsSerialized;
            this.PartId = res.PartId;
            this.TaxIdGroupId = res.TaxIdGroupId;
            this.TaxTypeId = res.TaxTypeId;
            this.partDescription = res.description;
            if (this.frmAddNewPart.controls['WarehouseId'].value != '' && this.IsSerialized == 1) {
                this.serialized = true;
                this._woService.getPartWareHouseQuantity(super.globalInfo().CompanyId, res.PartId, this.frmAddNewPart.controls['WarehouseId'].value)
                    .subscribe(s => {
                        this.frmAddNewPart.controls['AvailableQuantity'].setValue(s.count);
                    });
            }
            else {
                this.serialized = false;
                this.frmAddNewPart.controls['WarehouseId'].setValue('');
                this.frmAddNewPart.controls['AvailableQuantity'].setValue('');
            }

        }

        // if (this.jobStatusId == 2 || this.jobStatusId == 3 || this.jobStatusId == 4) {
        //     this._woService.getPartWareHouse(super.globalInfo().CompanyId, this.jobId)
        //         .subscribe(s => {
        //             this.partWareHouse = s;
        //         });
        // }
        // else {
        //     this.partWareHouse = [];
        // }

        this.islookup = false;
    }

    openSerialLookup() {
        this.PartId = this.PartId;
        this.WhId = this.frmAddNewPart.controls['WarehouseId'].value;
        this.SerialNo = this.frmAddNewPart.controls['SerialNo'].value;
        this.serialNumber = this.serialNumber;
        this.isseriallookup = true;
    }

    closeserialsearch(responsedata: any) {

        if (responsedata != 0)
            this.serialNumber = responsedata;
        else
            this.serialNumber = [];
        this.isseriallookup = false;
    }

    delete(serial: SerialNumber) {
        var x = this.serialNumber.indexOf(serial);
        this.serialNumber.splice(x, 1);
    }

    onBeforeSend(event) {
        var ac_token = this.authService.getAuthorizationHeaderValue();
        event.xhr.setRequestHeader('Authorization', ac_token);
    }

    dowoloadFiles() {
        var url = API.VENDORATTACH + '/DownloadOem?CompanyId=' + this.globalInfo().CompanyId + "&PartRequestId=" + this.partRequestId + "&FileName=" + this.editPart.Attachement;
        window.location.href = url;
        return;
    }

    isNumberKey(event, allowDot: boolean = false) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (event.shiftKey)
            return false;

        if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode == 46 || charCode == 8))
            return false;
        else {
            if (!allowDot && (charCode == 46 || charCode == 8))
                return false;

            var len = event.target.value.length;
            var index = event.target.value.indexOf('.');
            if (index > 0 && charCode == 46)
                return false;
            if (index > 0) {
                var CharAfterdot = (len + 1) - index;
                if (CharAfterdot > 3)
                    return false;
            }
        }
        return true;
    }

}